(async () => {

  if (!customElements.get('product-recommendations')) {

    const { default: Swiper, Navigation, Pagination, Scrollbar, Autoplay } = await import("swiper");

    Swiper.use([
      Navigation,
      Pagination,
      Scrollbar,
      Autoplay
    ]);
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        this.swiperElement = this.querySelector('[data-swiper-recommended-products]');

        this.swiperOptions = {
          loop: false,
          autoplay: false,
          direction: 'horizontal',

          threshold: 10,
          slidesPerView: 1,
          breakpoints: {
            640: {
              slidesPerView: 1,
            },
            1024: {
              slidesPerView: 3
            },
            1280: {
              slidesPerView: 4
            }
          }
        }

        // Check if we have extra options on the HTML
        if (this && this.swiperElement.dataset && this.swiperElement.dataset.options) {
          const jsonOptions = parseJson(this.swiperElement.dataset.options);
          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            }
          }
        }

        // Get product id's and slides that we we would like to keep
        this.slideIds = [];
        this.slides = ''
        this.querySelectorAll('[data-slide-id]').forEach((slide) => {
          this.slideIds = [...this.slideIds, slide.dataset.slideId];
          this.slides += slide.outerHTML;
        })

        // Init swiper
        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

        // Only do it once, not on every web component render.
        window.onload = () => {
          this.init();
        }
      }

      init() {
        if (this.dataset && this.dataset.url) {


          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              // Load recommended products
              const html = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('[data-recommended-products]');

              // Only add new slides and no doubles
              html.querySelectorAll('[data-slide-id]').forEach((slide) => {
                const id = slide.dataset.slideId;
                if (!this.slideIds.includes(id)) {
                  this.slides += slide.outerHTML;
                }
              });

              // Replace the slides
              this.querySelector('[data-recommended-products]').innerHTML = this.slides;

              // Update swiper and related functionality
              this.swiperInstance.update();
              if (this.swiperOptions.loop) {
                this.swiperInstance.loopDestroy();
                this.swiperInstance.loopCreate();
              }
              if (this.swiperOptions.navigation) {
                this.swiperInstance.navigation.init();
                this.swiperInstance.navigation.update();
              }
              if (this.swiperOptions.pagination) {
                this.swiperInstance.pagination.init();
                this.swiperInstance.pagination.update();
              }
              if (this.swiperOptions.scrollbar) {
                this.swiperInstance.scrollbar.init();
                this.swiperInstance.scrollbar.updateSize();
              }
            })
            .catch((error) => {
              console.error(error);
            });
        }
      }
    }

    window.ProductRecommendations = ProductRecommendations;

    customElements.define('product-recommendations', ProductRecommendations);

  }

})();
